// ============================================
// services/loginPrompt.ts
// 全局"要求登录"机制（2026-05-23）
//   - 任何组件需要登录时调 requireLogin()，全站统一弹出登录框
//   - Layout 监听 LOGIN_PROMPT_EVENT 来打开 LoginModal
//   - 用自定义事件实现，避免改动整棵组件树
// ============================================

import { isLoggedIn } from './auth';

export const LOGIN_PROMPT_EVENT = 'hipiido:require-login';

/**
 * 打开全局登录框。
 */
export function openLoginModal(): void {
  window.dispatchEvent(new CustomEvent(LOGIN_PROMPT_EVENT));
}

/**
 * 需要登录的操作前置检查：
 *   已登录 → 返回 true，调用方继续执行
 *   未登录 → 弹登录框，返回 false，调用方应中止
 */
export function requireLogin(): boolean {
  if (isLoggedIn()) return true;
  openLoginModal();
  return false;
}
